export default __webpack_public_path__ + "static/media/delete_icon.91539b3c.svg";